import { useCallback } from 'react';

import { onePageStylesAccessRules } from 'layouts/OnePagePreviewLayout/constants/onePageStyleAccessRules';
import { IOnePageStyles } from 'layouts/OnePagePreviewLayout/types';
import { useUserSubscriptionStore } from 'store/useUserSubscriptionStore';
import { getUserSubscription } from 'store/useUserSubscriptionStore/selectors';

import { SUBSCRIPTION_PLAN } from 'interfaces/subscriptions';

// TODO move to the common folder for one page
export const useOnePageStyleAvailability = () => {
  const userSubscription = useUserSubscriptionStore(getUserSubscription);
  const subscriptionPlan = userSubscription?.currentSubscription?.subscriptionPlan || SUBSCRIPTION_PLAN.UNAUTHORIZED;

  const getIsOnePageStyleAvailable = useCallback(
    (style: IOnePageStyles) => (onePageStylesAccessRules[subscriptionPlan] as IOnePageStyles[]).includes(style),
    [],
  );

  return {
    getIsOnePageStyleAvailable,
  };
};
